module.exports = __webpack_public_path__ + "static/media/tim-crayon.83bd6a04.png";